/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetUserPreferencesOptions, GetUserPreferencesResponses } from '../../models/GetUserPreferences'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Get Preferences
 * {@link /user/preferences}
 */
export function getUserPreferences<ThrowOnError extends boolean = true>(options: Options<GetUserPreferencesOptions, ThrowOnError> = {}): Promise<UnwrappedResult<GetUserPreferencesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/user/preferences', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetUserPreferencesResponses, ThrowOnError>>
}
